module.exports = __webpack_public_path__ + "img/silver1.e2e5344f.png";